import { view } from "@/mega-ui/helpers/function"

export const settings = {
    path: '/settings',
    name: 'settings',
    children: [
        {
            path: 'main',
            name: 'settings-main',
            meta: {
                withAuth: true,
            },
            component: () => view('settings/SettingsMainView')
        },
        {
            path: 'alerts',
            name: 'alerts',
            meta: {
                withAuth: true,
            },
            component: () => view('settings/NotificationsView')
        },
        {
            path: 'payment',
            name: 'payment',
            meta: {
                withAuth: true,
            },
            component: () => view('settings/PaymentView')
        },
        {
            path: 'contact',
            name: 'contact',
            meta: {
                withAuth: true,
            },
            component: () => view('settings/ContactView')
        }
    ],
}